<template>
  <Modal
    ref="modalRef"
    class="tip-img"
    v-bind="$attrs"
    v-on="$listeners"
    :maskClosable="false"
    :useCloseBtn="true"
  >
    <div>
      <p class="tip-img-text" v-if="tip">{{ tip }}</p>
      <div class="tip-img-wrap">
        <img
          v-for="(img, index) in tipImg"
          :key="index"
          :src="img"
          class="tip-img-item"
          @click="previewImg(index)"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  props: ['tipImg', 'tip'],
  methods: {
    previewImg(index) {
      ImagePreview({
        images: this.tipImg,
        startPosition: index
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tip-img {
  &-text {
    margin-top: 6px;
    margin-bottom: 20px;
    font-size: 18px;
    text-align: left;
    line-height: 30px;
    /* 弹窗为浅色底；暗黑主题下勿继承页面白色字 */
    color: #333333;
  }
  &-wrap {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: scroll;
    align-items: center;
  }
  &-item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
